import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap"
import { NavLink } from "react-router-dom"

import { useStore } from "@/zustand/store"
import { useTranslation } from "react-i18next"

interface SideBarItemProps {
  title: string
  route: string
  icon: React.ReactNode
  disabled?: boolean
  count?: number
  isNew?: boolean
}

export default function SideBarItem({
  title,
  route,
  icon,
  disabled,
  count,
  isNew,
}: SideBarItemProps) {
  const { sideBarOpen, setSideBarOpen } = useStore((state) => state)
  const { t, i18n } = useTranslation()

  if (disabled) {
    return (
      <OverlayTrigger
        placement={"right"}
        overlay={
          <Tooltip id="tooltip" style={{ position: "fixed" }}>
            {title}
          </Tooltip>
        }
      >
        <div className="nav__item d-flex gap-3 align-items-center px-4 disabled-link">
          <span className="list-icon position-relative">
            {icon}
            {typeof count === "number" && count > 0 && (
              <Badge
                className="position-absolute d-flex justify-content-center align-items-center top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{
                  fontSize: "10px",
                  width: "20px",
                  height: "20px",
                }}
              >
                {count}
              </Badge>
            )}
          </span>
          <p>{!sideBarOpen && title}</p>
        </div>
      </OverlayTrigger>
    )
  }

  return (
    <OverlayTrigger
      placement={"right"}
      overlay={
        <Tooltip id="tooltip" style={{ position: "fixed" }}>
          {title}
        </Tooltip>
      }
    >
      <NavLink
        to={route}
        style={{
          ...(isNew
            ? {
                backgroundImage: `linear-gradient(${i18n.language === "ar" ? "-135deg" : "135deg"}, #1d2c4b, #2360e5)`,
                border: "2px solid #e6c50eff",
                borderInlineStartWidth: "6px",
              }
            : {}),
          transition: "all 0.3s ease-in-out",
        }}
        className={`nav__item d-flex gap-3 align-items-center ${isNew ? "px-3" : "px-4"}`}
        onClick={() => {
          if (!sideBarOpen && window.innerWidth < 600) {
            setSideBarOpen()
          }
        }}
      >
        <span className="list-icon position-relative">
          {icon}
          {typeof count === "number" && count > 0 && (
            <Badge
              className="position-absolute top-0 start-100 translate-middle rounded-pill bg-primary"
              style={{ fontSize: "0.65rem" }}
            >
              {count}
            </Badge>
          )}
        </span>
        <p>{!sideBarOpen && title}</p>
        <Badge
          pill
          className="bg-danger"
          style={{
            fontSize: "0.85rem",
            opacity: isNew ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {t("sidebar.isNew")}
        </Badge>
      </NavLink>
    </OverlayTrigger>
  )
}
